import React, { useEffect, useState, useCallback, useRef } from "react";
import { NavLink } from "react-router-dom";
import { getFieldData } from "../../Services/appService";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentUser,
  getLoggedUserDetails,
} from "../../app/store/auth";
import {
  getComponentUpdateStatus,
  getComponentUserStatus,
  getPermission,
  getToolsCount,
  loadComponentUserStatus,
  loadPermissions,
  loadToolsCount,
} from "../../app/store/tools";
import { getPartnerDetails, loadPartnerDetails } from "../../app/store/partner";
import { useGetUserDetailsQuery, useGetPartnerUserDetailsQuery } from "../../app/store/authApiSlice";
import {
  useLoadCandidateAppsQuery,
  useLoadCandidateAppAllTasksQuery,
  useLoadAppRuningTasksQuery,
} from "../../app/store/candidateApiSlice";

const EMPTY_ARRAY = [];

const Menu = ({ isCollapsed = false, onToggleCollapse }) => {
  const state = {
    isSelected: null,
    currentUser: "",
    docsCount: 0,
    bcCount: 0,
    recDoc: 0,
    sentDoc: 0,
    frmLibraryDoc: 0,
    achFrmLibraryDoc: 0,
    insFrmLibraryDoc: 0,
    meetingCount: 0,
    msgCount: 0,
    poOrderCount: 0,
  };

  const c2cPhases = [
    { id: 1, wfPhase: "Application" },
    { id: 2, wfPhase: "Review" },
    { id: 3, wfPhase: "Onboarding" },
    { id: 4, wfPhase: "Time Log" },
    { id: 5, wfPhase: "Invoice" },
    { id: 6, wfPhase: "Approved" },
    { id: 7, wfPhase: "Denied" },
    { id: 8, wfPhase: "Compliance" },
  ];

  const w2Phases = [
    "Application",
    "Review",
    "Onboarding",
    "Time Log",
    "Invoice",
    "Approved",
    "Denied",
    "Compliance",
  ];

  const [entityType, setEntityType] = useState("");
  const [rptNotify, setRptNotify] = useState("");
  const [toolsCounts, setToolsCounts] = useState([]);
  const [appTasklist, setAppTasklist] = useState([]);
  const [allPhases, setAllPhases] = useState([]);
  const [taskAllPhases, setTaskAllPhases] = useState([]);
  const [rolePermission, setRolePermission] = useState([]);
  const [partnerDetails, setPartnerDetails] = useState([]);
  const [appStatus, setAppStatus] = useState(false);
  const [appApproved, setAppApproved] = useState(false);
  const [isHoverExpanded, setIsHoverExpanded] = useState(false);
  const lastComponentStatusLoadRef = useRef("");

  const userDetailSelector = useSelector(getLoggedUserDetails);
  const partnerDetailsSelector = useSelector(getPartnerDetails);
  const toolsCountSelector = useSelector(getToolsCount);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);
  const componentUpdateStatusSelector = useSelector(getComponentUpdateStatus);
  const appPermissionDataSel = useSelector(getPermission);

  const usrTypeRaw = localStorage.getItem("userType");
  const usrType = (usrTypeRaw?.toLowerCase() === "applicant" || usrTypeRaw?.toLowerCase() === "candidate")
    ? "candidate"
    : (usrTypeRaw?.toLowerCase() || "");
  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  const userId = currentUser?.id;
  const linkUserId = currentUser?.linkUser;
  const usrId = linkUserId || userId;

  // Retrieve user details using RTK Query
  useGetUserDetailsQuery(userId, { skip: !userId || !!linkUserId });
  useGetPartnerUserDetailsQuery(userId, { skip: !userId || !linkUserId });

  // Retrieve candidate applications using RTK Query
  const { data: candidateAppsSelector = EMPTY_ARRAY } = useLoadCandidateAppsQuery(usrId, { skip: !usrId });

  // Retrieve candidate all tasks using RTK Query
  const { data: appAllTasks = EMPTY_ARRAY } = useLoadCandidateAppAllTasksQuery(
    usrId,
    { skip: !usrId || usrType !== "candidate" }
  );

  // Retrieve running tasks using RTK Query
  const mainWorkflow = candidateAppsSelector?.filter((x) => x.workflowType === 1);
  const wfId = mainWorkflow?.[0]?.oldWorkflowId;
  const runningTasksUserId = usrType === "candidate" ? userId : partnerDetails?.contact1?.performerid;

  const { data: appTasksSelector = EMPTY_ARRAY } = useLoadAppRuningTasksQuery(
    { wfId, userId: runningTasksUserId },
    { skip: !wfId || !runningTasksUserId }
  );

  useEffect(() => {
    if (userDetailSelector) {
      const entType = getFieldData(
        userDetailSelector.performerData,
        "candidateonboardingform",
        "CandidateEntity"
      );
      setEntityType(entType);
      const isSent = getFieldData(
        userDetailSelector.performerData,
        "reportingdetails",
        "isSent"
      );
      setRptNotify(isSent);
      setAppStatus(userDetailSelector?.appSubmit);
      setAppApproved(userDetailSelector?.approved > 0);

      if (userDetailSelector?.partnerid && partnerDetailsSelector == null)
        dispatch(loadPartnerDetails(userDetailSelector.partnerid));
    }
  }, [userDetailSelector, partnerDetailsSelector, dispatch]);

  useEffect(() => {
    if (userId > 0) {
      dispatch(loadToolsCount(usrId));
      if (usrType !== "candidate") {
        dispatch(loadPermissions(userId));
      }
    }
  }, [dispatch, userId, usrId, usrType]);

  useEffect(() => {
    setPartnerDetails(partnerDetailsSelector);
  }, [partnerDetailsSelector]);

  useEffect(() => {
    if (appPermissionDataSel.length > 0) {
      setRolePermission(appPermissionDataSel);
    }
  }, [appPermissionDataSel]);

  useEffect(() => {
    if (appTasksSelector.length > 0) {
      let phs = [];

      const filterTasks = appTasksSelector
        .filter((x) => x.wiid > 0)
        .sort((a, b) => a.orderNumber - b.orderNumber);

      filterTasks.forEach((p, key) => {
        if (phs.findIndex((x) => x.wfPhase === p.wfPhase) === -1)
          phs.push({ id: key + 1, wfPhase: p.wfPhase });
      });
      // if (usrType !== "candidate")
      //   phs = phs.filter(x => x.wfPhase !== "Approved");
      setTaskAllPhases(phs);
      setAppTasklist(filterTasks);
    }
  }, [appTasksSelector]);

  useEffect(() => {
    if (toolsCountSelector.length > 0) {
      setToolsCounts(toolsCountSelector);
      const appObj = toolsCountSelector.filter((x) => x.key === 0);
      if (appObj.length > 0) {
        const componentStatusKey = `${usrId}|${appObj[0].value}`;
        if (lastComponentStatusLoadRef.current !== componentStatusKey) {
          lastComponentStatusLoadRef.current = componentStatusKey;
          dispatch(loadComponentUserStatus(usrId, appObj[0].value));
        }
      }
    }
  }, [toolsCountSelector, usrId, dispatch]);

  const getCount = (id) => {
    if (!toolsCountSelector) return 0;
    const toolObj = toolsCountSelector.filter((x) => x.key == id);
    if (toolObj.length > 0) return toolObj[0].value;
    return 0;
  };

  const getToolCount = (id) => {
    const compObj = componentUserStatusSelector.filter((x) => x.compId === id);
    if (compObj.length > 0) {
      const unreadComps = compObj[0].unreadCompItems.split(",").sort();
      const readComps = compObj[0].compItems.split(",").sort();
      let unReadCount = 0;
      unreadComps
        .filter((x) => x !== "")
        .forEach((x) => {
          const rs = readComps.filter((y) => y === x);
          if (rs.length === 0) {
            unReadCount += 1;
          }
        });
      if (unReadCount === 0) {
        return (
          <span className="badge badge-pill badge-success ml-1 text-dark">
            {getCount(id)}
          </span>
        );
      } else {
        return (
          <span className="badge badge-pill badge-danger ml-1">
            {unReadCount}
          </span>
        );
      }
    } else {
      return (
        <span className="badge badge-pill badge-danger ml-1">
          {getCount(id)}
        </span>
      );
    }
  };

  useEffect(() => {
    if (componentUpdateStatusSelector) {
      dispatch(loadToolsCount(usrId));
    }
  }, [componentUpdateStatusSelector, usrId, dispatch]);

  const getPhaseColor = (phase) => {
    const app = [];
    const totalPhases = allPhases;
    var keyCount = 0;
    let phaseBg = "btn-wf-default";
    totalPhases.map((item) => {
      let keyNum = 5;
      if (item.wfPhase === "Application") keyNum = 1;
      if (item.wfPhase === "Review" || item.wfPhase === "Onboarding")
        keyNum = 2;
      if (item.wfPhase === "Approved") keyNum = 3;
      if (item.wfPhase === "Denied") keyNum = 4;
      if (keyNum === 5) {
        keyNum += keyCount;
        keyCount += 1;
      }

      if (item.wfPhase === phase) {
        phaseBg = `btn-wf${keyNum}-default`;
      }
    });

    return phaseBg;
  };

  const hasCheckedPermission = (items = []) => {
    return items.some(
      (item) =>
        item?.isChecked === true || hasCheckedPermission(item?.menus ?? [])
    );
  };

  const parseMenuPermissionKey = (mid) => {
    return String(mid)
      .split("_")
      .reduce((ids, item) => {
        const match = item.match(/^(sssm|ssm|sm|m)(\d+)$/);
        if (match) {
          ids[match[1]] = parseInt(match[2], 10);
        }
        return ids;
      }, {});
  };

  const findPermissionNode = (items = [], key, ids) => {
    const id = ids[key];
    if (!id) return null;
    return items.find((item) => item.id === id) ?? null;
  };

  const checkMenuPermission = (mid) => {
    // const { rolePermission } = this.state;
    if (!rolePermission) return;
    if (currentUser?.type === "admin" || !currentUser.linkUser) return true;
    const ids = parseMenuPermissionKey(mid);
    const menu = findPermissionNode(rolePermission, "m", ids);
    if (!menu) return false;

    const smenu = findPermissionNode(menu.menus, "sm", ids);
    if (!ids.sm) {
      return menu.isChecked === true || hasCheckedPermission(menu.menus ?? []);
    }

    if (!smenu) return false;
    const ssmenu = findPermissionNode(smenu.menus, "ssm", ids);
    if (!ids.ssm) return smenu.isChecked === true;

    if (!ssmenu) return false;
    const sssmenu = findPermissionNode(ssmenu.menus, "sssm", ids);
    if (!ids.sssm) return ssmenu.isChecked === true;

    return sssmenu?.isChecked === true;
  };

  const getMenuIconClass = (label) => {
    switch (label) {
      case "Manage Users":
        return "fa-users";
      case "Onboarding Form":
        return "fa-file-text-o";
      case "Contract Management":
        return "fa-folder-open-o";
      case "ACH Information":
        return "fa-university";
      case "Insurance Information":
        return "fa-shield";
      case "Check Onbording Status":
      case "Check Onboarding Status":
        return "fa-clipboard";
      case "Background Check":
        return "fa-search";
      case "Reporting Details":
        return "fa-address-card-o";
      case "Time Logs":
      case "Time Logs and Payments":
        return "fa-clock-o";
      case "List of Candidates":
        return "fa-list-ul";
      case "Invoice and Payments":
        return "fa-money";
      case "Compliance":
        return "fa-check-square-o";
      case "Message(s)":
        return "fa-comments-o";
      case "Forms":
        return "fa-files-o";
      case "Document History":
        return "fa-folder-open-o";
      case "Reports":
        return "fa-bar-chart";
      case "Schedule Appointments":
        return "fa-calendar";
      case "Surveys":
        return "fa-commenting-o";
      default:
        return "fa-circle-o";
    }
  };

  useEffect(() => {
    if (!isCollapsed && isHoverExpanded) {
      setIsHoverExpanded(false);
    }
  }, [isCollapsed, isHoverExpanded]);

  const isCollapsedRail = isCollapsed && !isHoverExpanded;
  const isEffectivelyExpanded = !isCollapsedRail;
  const showCollapsedBrandRail = isCollapsedRail;
  const canShowOnboardingMenu =
    usrType === "candidate" || checkMenuPermission("m2");

  const renderMenuLabel = (label, trailing = null) => (
    <>
      <span className="menu-link-main">
        <i className={`fa ${getMenuIconClass(label)} menu-link-icon`} aria-hidden="true"></i>
        {isEffectivelyExpanded && <span>{label}</span>}
      </span>
      {isEffectivelyExpanded && trailing}
    </>
  );

  return (
    <nav
      className="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white shadow-none"
      id="sidenav-main"
      data-collapsed={isCollapsedRail ? "true" : "false"}
      data-hovered={isHoverExpanded ? "true" : "false"}
      onMouseEnter={() => {
        if (isCollapsed) setIsHoverExpanded(true);
      }}
      onMouseLeave={() => {
        if (isCollapsed) setIsHoverExpanded(false);
      }}
    >
      <style>{`
        #sidenav-main {
          background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
          border-right: 1px solid rgba(203, 213, 225, 0.8);
          box-shadow: 8px 0 24px rgba(15, 23, 42, 0.05);
          overflow: hidden;
          height: 100% !important;
          max-height: none !important;
          bottom: 0 !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"],
        #sidenav-main[data-collapsed="true"][data-hovered="false"]:hover,
        #sidenav-main[data-collapsed="true"][data-hovered="false"]:focus,
        #sidenav-main[data-collapsed="true"][data-hovered="false"]:focus-within {
          width: 120px !important;
          min-width: 120px !important;
          max-width: 120px !important;
          transform: none !important;
        }

        #sidenav-main[data-collapsed="false"][data-hovered="true"],
        #sidenav-main[data-collapsed="false"][data-hovered="false"] {
          width: 320px !important;
          min-width: 320px !important;
          max-width: 320px !important;
          box-shadow: 12px 0 30px rgba(15, 23, 42, 0.12);
        }

        #sidenav-main[data-collapsed="false"] .navbar-brand {
          display: flex !important;
          align-items: center;
          justify-content: flex-start;
          width: auto;
        }

        #sidenav-main[data-collapsed="false"] .sidenav-header {
          flex-direction: row;
          align-items: center !important;
          justify-content: space-between;
          gap: 0;
          padding-bottom: 12px;
        }

        #sidenav-main[data-collapsed="false"] .ml-auto {
          margin-left: auto !important;
          width: auto;
          display: block;
        }

        #sidenav-main[data-collapsed="false"] .navbar-heading {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          max-width: none;
        }

        #sidenav-main[data-collapsed="false"] .navbar-heading i {
          margin-right: 0.5rem !important;
        }

        #sidenav-main .scrollbar-inner {
          height: 100%;
          overflow-y: auto;
          overflow-x: hidden;
          padding: 14px 10px 80px 10px;
          // scrollbar-gutter: stable;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .scrollbar-inner {
          padding-left: 12px;
          padding-right: 12px;
        }

        #sidenav-main .navbar-nav {
          gap: 8px;
          padding-bottom: 100px !important;
        }

        #sidenav-main .nav.nav-sm {
          padding-left: 0;
          margin-left: 0;
        }

        #sidenav-main .nav-item {
          margin-bottom: 2px;
        }

        #sidenav-main .navbar-heading {
          background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
          border: 1px solid rgba(203, 213, 225, 0.7) !important;
          border-radius: 14px !important;
          padding: 11px 14px !important;
          font-size: 14px;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          color: #1e293b !important;
          box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .navbar-heading {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 11px 8px !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .navbar-heading i {
          margin-right: 0 !important;
        }

        #sidenav-main .collapse.show {
          margin-top: 6px;
        }

        #sidenav-main .nav-link {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          width: 100%;
          box-sizing: border-box;
          min-height: 42px;
          padding: 10px 14px !important;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          color: #1f2937 !important;
          transition: background-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
        }

        #sidenav-main .nav-link:hover {
          background: rgba(37, 99, 235, 0.08);
          box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.08);
          transform: none;
          text-decoration: none;
        }

        #sidenav-main .nav-link.active {
          background: linear-gradient(135deg, rgba(29, 78, 216, 0.12) 0%, rgba(37, 99, 235, 0.08) 100%);
          color: #163b73 !important;
          box-shadow: inset 3px 0 0 #2563eb, 0 10px 20px rgba(37, 99, 235, 0.08);
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav-link {
          justify-content: center;
          padding-left: 10px !important;
          padding-right: 10px !important;
          min-height: 56px;
        }

        #sidenav-main[data-collapsed="true"] .navbar-brand {
          display: flex !important;
          align-items: center;
          justify-content: center;
          width: 100%;
          margin-left: 0 !important;
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        #sidenav-main[data-collapsed="true"] .sidenav-header {
          flex-direction: column;
          gap: 10px;
          padding-bottom: 10px;
          align-items: center !important;
        }

        #sidenav-main[data-collapsed="true"] .ml-auto {
          margin-left: 0 !important;
          width: 100%;
          display: flex;
          justify-content: center;
        }

        #sidenav-main .menu-link-main {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          min-width: 0;
          flex: 1;
        }

        #sidenav-main .menu-link-main > span {
          white-space: nowrap;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .menu-link-main {
          width: 100%;
          justify-content: center;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav-item {
          display: flex;
          justify-content: center;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav-link,
        #sidenav-main[data-collapsed="true"][data-hovered="false"] .navbar-heading {
          width: 100%;
          min-width: 100%;
          max-width: 100%;
          border-radius: 16px !important;
        }

        #sidenav-main .menu-link-icon {
          width: 18px;
          text-align: center;
          color: #47648d;
          font-size: 14px;
          flex-shrink: 0;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .menu-link-icon {
          width: auto;
          font-size: 16px;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .menu-link-main > span {
          display: none;
        }

        #sidenav-main .nav-link.active .menu-link-icon {
          color: #1d4ed8;
        }

        #sidenav-main .badge.badge-pill {
          min-width: 30px;
          padding: 6px 9px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 600;
          box-shadow: 0 6px 12px rgba(15, 23, 42, 0.08);
          margin-left: auto !important;
          flex-shrink: 0;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .badge.badge-pill {
          position: absolute;
          right: 6px;
          top: 50%;
          transform: translateY(-50%);
          min-width: 25px;
          height: 25px;
          padding: 0 8px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 11px;
          line-height: 1;
        }

        #sidenav-main .sidebar-brand-mark {
          width: 44px;
          height: 44px;
          border-radius: 14px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #163b73 0%, #355b92 100%);
          color: #ffffff;
          font-size: 20px;
          font-weight: 600;
          box-shadow: 0 10px 24px rgba(22, 59, 115, 0.18);
        }

        #sidenav-main .menu-toggle {
          width: 42px;
          height: 42px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(203, 213, 225, 0.85);
          border-radius: 12px;
          background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
          cursor: pointer;
          box-shadow: 0 8px 18px rgba(15, 23, 42, 0.05);
        }

        #sidenav-main .menu-toggle i {
          font-size: 22px;
          color: #243b68;
          line-height: 1;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .menu-toggle {
          width: 44px;
          height: 44px;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav-link {
          position: relative;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav.nav-sm .nav-link {
          margin-left: 0 !important;
          padding-left: 10px !important;
          padding-right: 10px !important;
        }
      `}</style>
      <div className="scrollbar-inner">
        <div className="sidenav-header d-flex align-items-center">
          <a
            className="navbar-brand"
            href="/"
            style={{ padding: "12px", marginLeft: isCollapsed ? "4px" : "18px" }}
          >
            {showCollapsedBrandRail ? (
              <span className="sidebar-brand-mark">W</span>
            ) : (
              <img
                src="/assets/img/wflogoblack.png"
                className="navbar-brand-img"
                alt="Workfinity"
              />
            )}
          </a>

          <div className="ml-auto">
            <button
              type="button"
              className="menu-toggle"
              onClick={onToggleCollapse}
              role="button"
              aria-label={showCollapsedBrandRail ? "Expand menu" : "Collapse menu"}
            >
              <i
                className={`fa ${showCollapsedBrandRail ? "fa-bars" : "fa-angle-left"}`}
                aria-hidden="true"
              ></i>
            </button>
          </div>
        </div>
        <div className="navbar-inner" style={{ marginTop: "-18px" }}>
          <div className="collapse navbar-collapse" id="sidenav-collapse-main">
            <ul className="navbar-nav">
              {(checkMenuPermission("m1")) &&
                usrType !== "candidate" && (
                  <React.Fragment>
                    <li className="nav-item">
                      <h6
                        className="navbar-heading mb-0 btn p-2 rounded-0 text-left text-dark border-right-0"
                        style={{ border: "1px solid #ccc", fontWeight: 600 }}
                      >
                        <i
                          className="fa fa-user-circle-o mr-2"
                          aria-hidden="true"
                        ></i>
                        {isEffectivelyExpanded ? "Administration" : null}
                      </h6>
                    </li>
                    {checkMenuPermission("sm1_m1") && (
                      <li className="nav-item">
                        <NavLink
                          style={{ color: "black" }}
                          to="/ManagePartnerUsers"
                          className="nav-link"
                          title="You may add as many users to access the portal."
                        >
                          {renderMenuLabel("Manage Users")}
                        </NavLink>
                      </li>
                    )}
                  </React.Fragment>
                )}
              {canShowOnboardingMenu && (
                <>
                  <li className="nav-item">
                    <h6
                      className="navbar-heading mb-0 btn p-2 rounded-0 text-left text-dark"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                        borderTop: "1px solid #dee2e6",
                        fontWeight: 600,
                      }}
                    >
                      <i className="fa fa-desktop mr-2" aria-hidden="true"></i>
                      {isEffectivelyExpanded ? "Onboarding" : null}
                    </h6>
                  </li>
                  <ul className="nav flex-column">
                <li className="nav-item">
                  {(usrType === "candidate" ||
                    checkMenuPermission("sm1_m2")) && <NavLink
                      style={{ color: "black" }}
                      to="/Onboarding"
                      className="nav-link stepMenu"
                    >
                      {renderMenuLabel("Onboarding Form", appStatus ? (
                        <i className="fa fa-solid fa-check text-success ml-1"></i>
                      ) : (
                        <i className="fa fa-solid fa-times text-warning ml-1"></i>
                      ))}
                    </NavLink>}

                </li>
                <li className="nav-item">
                  {(usrType === "candidate" ||
                    checkMenuPermission("sm2_m2")) && (
                      <NavLink
                        style={{ color: "black" }}
                        to="/ContractDocs"
                        className="nav-link stepMenu"
                      >
                        {renderMenuLabel("Contract Management", appApproved ? (
                          <i className="fa fa-solid fa-check text-success ml-1"></i>
                        ) : (
                          <i className="fa fa-solid fa-times text-warning ml-1"></i>
                        ))}
                        {getToolCount(3)}
                      </NavLink>
                    )}
                </li>
                {usrType !== "candidate" && (
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      {(checkMenuPermission("sm3_m2")) && (
                        <NavLink
                          style={{ color: "black" }}
                          to="/AchInfo"
                          className="nav-link stepMenu"
                        >
                          {renderMenuLabel("ACH Information", appApproved ? (
                            <i className="fa fa-solid fa-check text-success ml-1"></i>
                          ) : (
                            <i className="fa fa-solid fa-times text-warning ml-1"></i>
                          ))}
                          {getToolCount(20)}
                        </NavLink>
                      )}
                    </li>
                    <li className="nav-item">
                      {(checkMenuPermission("sm4_m2")) && (
                        <NavLink
                          style={{ color: "black" }}
                          to="/InsuranceInfo"
                          className="nav-link"
                        >
                          {renderMenuLabel("Insurance Information", appApproved ? (
                            <i className="fa fa-solid fa-check text-success ml-1"></i>
                          ) : (
                            <i className="fa fa-solid fa-times text-warning ml-1"></i>
                          ))}
                          {getToolCount(21)}
                        </NavLink>
                      )}
                    </li>
                  </ul>
                )}
                {usrType === "candidate" && entityType !== "C2C Basis" && (
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <NavLink
                        style={{ color: "black" }}
                        to="/AchInfo"
                        className="nav-link"
                      >
                        {renderMenuLabel("ACH Information", appApproved ? (
                          <i className="fa fa-solid fa-check text-success ml-1"></i>
                        ) : (
                          <i className="fa fa-solid fa-times text-warning ml-1"></i>
                        ))}
                        {getToolCount(20)}
                      </NavLink>
                    </li>
                  </ul>
                )}
                {usrType === "candidate" && (
                  <li className="nav-item">
                    <NavLink
                      style={{ color: "black" }}
                      to="/BackgroundChecks"
                      className="nav-link stepMenu"
                    >
                      {renderMenuLabel("Background Check", appApproved ? (
                        <i className="fa fa-solid fa-check text-success ml-1"></i>
                      ) : (
                        <i className="fa fa-solid fa-times text-warning ml-1"></i>
                      ))}
                      {getToolCount(26)}
                    </NavLink>
                  </li>
                )}

                <li className="nav-item">
                  {(usrType === "candidate" ||
                    checkMenuPermission("sm6_m2")) && (
                      <NavLink
                        style={{ color: "black" }}
                        to="/OnboardingStatus"
                        className="nav-link stepMenu"
                      >
                        {renderMenuLabel("Check Onbording Status", appApproved ? (
                          <i className="fa fa-solid fa-check text-success ml-1"></i>
                        ) : (
                          <i className="fa fa-solid fa-times text-warning ml-1"></i>
                        ))}
                      </NavLink>
                    )}
                </li>
                {usrType === "candidate" && (
                  <>
                    <li className="nav-item">
                      <NavLink
                        style={{ color: "black" }}
                        to="/ReportingDetails"
                        className="nav-link stepMenu"
                      >
                        {renderMenuLabel("Reporting Details", appApproved ? (
                          <i className="fa fa-solid fa-check text-success ml-1"></i>
                        ) : (
                          <i className="fa fa-solid fa-times text-warning ml-1"></i>
                        ))}
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        style={{ color: "black" }}
                        to="/TimeLogs"
                        className="nav-link stepMenu"
                      >
                        {renderMenuLabel(
                          entityType !== "C2C Basis" ? "Time Logs and Payments" : "Time Logs",
                          appAllTasks.filter(
                            (x) => x.loanPhase_Desc === "Time Log"
                          ).length > 0 ? (
                            <i className="fa fa-solid fa-check text-success ml-1"></i>
                          ) : (
                            <i className="fa fa-solid fa-times text-warning ml-1"></i>
                          )
                        )}
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        style={{ color: "black" }}
                        to="/Compliance"
                        className="nav-link stepMenu"
                      >
                        {renderMenuLabel("Compliance", appAllTasks.filter(
                          (x) => x.loanPhase_Desc === "Compliance"
                        ).length > 0 ? (
                          <i className="fa fa-solid fa-check text-success ml-1"></i>
                        ) : (
                          <i className="fa fa-solid fa-times text-warning ml-1"></i>
                        ))}
                      </NavLink>
                    </li>
                  </>
                )}

                {usrType !== "candidate" && (
                  <>
                    <li className="nav-item">
                      {(checkMenuPermission("sm10_m2")) && (
                        <NavLink
                          style={{ color: "black" }}
                          to="/PartnerCandidates"
                          className="nav-link stepMenu"
                        >
                          {renderMenuLabel("List of Candidates", appApproved ? (
                            <i className="fa fa-solid fa-check text-success ml-1"></i>
                          ) : (
                            <i className="fa fa-solid fa-times text-warning ml-1"></i>
                          ))}
                        </NavLink>
                      )}
                    </li>
                    <li className="nav-item">
                      {(checkMenuPermission("sm11_m2")) && (
                        <NavLink
                          style={{ color: "black" }}
                          to="/PartnerInvoices"
                          className="nav-link stepMenu"
                        >
                          {renderMenuLabel("Invoice and Payments", appApproved ? (
                            <i className="fa fa-solid fa-check text-success ml-1"></i>
                          ) : (
                            <i className="fa fa-solid fa-times text-warning ml-1"></i>
                          ))}
                        </NavLink>
                      )}
                    </li>
                  </>
                )}
                  </ul>
                </>
              )}



              {allPhases.map((p) => {
                return (
                  <li className="nav-item">
                    {(usrType === "candidate" ||
                      (p.wfPhase === "Onboarding"
                        ? checkMenuPermission("sm1_m2")
                        : p.wfPhase === "Time Log"
                          ? checkMenuPermission("sm10_m2")
                          : p.wfPhase === "Invoice"
                            ? checkMenuPermission("sm11_m2")
                            : true)) && (
                        <>
                          {/* <h3 className="nav-link active">
                          <div aria-label={`${p.wfPhase}`} className={`${getPhaseColor(p.wfPhase)} rounded border wf-box`}></div>
                          {p.wfPhase}
                        </h3> */}
                          <div className="collapse show">
                            <ul className="nav flex-column">
                              {appTasklist
                                .filter((x) => x.wfPhase === p.wfPhase)
                                .map((tsk, key) => {
                                  if (tsk.taskName === "Onboarding/Enrollment") {
                                    return (
                                      <li className="nav-item">
                                        <NavLink
                                          style={{ color: "black" }}
                                          to="/Onboarding"
                                          className="nav-link stepMenu"
                                        >
                                          {renderMenuLabel("Onboarding Form")}
                                        </NavLink>
                                      </li>
                                    );
                                  } else if (
                                    tsk.taskName === "Contract Management"
                                  ) {
                                    return (
                                      <li className="nav-item">
                                        {(usrType === "candidate" ||
                                          checkMenuPermission("sm2_m2")) && (
                                            <NavLink
                                              style={{ color: "black" }}
                                              to="/ContractDocs"
                                              className="nav-link stepMenu"
                                            >
                                              {renderMenuLabel("Contract Management")}
                                              {getToolCount(3)}
                                            </NavLink>
                                          )}

                                        {usrType !== "candidate" && (
                                          <ul className="nav nav-sm flex-column">
                                            <li className="nav-item">
                                              {(checkMenuPermission(
                                                "sm3_m2"
                                              )) && (
                                                  <NavLink
                                                    style={{ color: "black" }}
                                                    to="/AchInfo"
                                                    className="nav-link"
                                                  >
                                                    {renderMenuLabel("ACH Information")}
                                                    {getToolCount(20)}
                                                  </NavLink>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                              {(checkMenuPermission(
                                                "sm4_m2"
                                              )) && (
                                                  <NavLink
                                                    style={{ color: "black" }}
                                                    to="/InsuranceInfo"
                                                    className="nav-link"
                                                  >
                                                    {renderMenuLabel("Insurance Information")}
                                                    {getToolCount(21)}
                                                  </NavLink>
                                                )}
                                            </li>
                                          </ul>
                                        )}

                                        {usrType === "candidate" &&
                                          entityType !== "C2C Basis" && (
                                            <ul className="nav nav-sm flex-column">
                                              <li className="nav-item">
                                                <NavLink
                                                  style={{ color: "black" }}
                                                  to="/AchInfo"
                                                  className="nav-link"
                                                >
                                                  {renderMenuLabel("ACH Information")}
                                                  {getToolCount(20)}
                                                </NavLink>
                                              </li>
                                            </ul>
                                          )}
                                      </li>
                                    );
                                  } else if (
                                    tsk.taskName === "Background Check"
                                  ) {
                                    return (
                                      <li className="nav-item">
                                        <NavLink
                                          style={{ color: "black" }}
                                          to="/BackgroundChecks"
                                          className="nav-link stepMenu"
                                        >
                                          {renderMenuLabel("Background Check")}
                                          {getToolCount(26)}
                                        </NavLink>
                                      </li>
                                    );
                                  } else if (tsk.taskName === "Review") {
                                    return (
                                      <li className="nav-item">
                                        {(usrType === "candidate" ||
                                          checkMenuPermission("sm6_m2")) && (
                                            <NavLink
                                              style={{ color: "black" }}
                                              to="/OnboardingStatus"
                                              className="nav-link stepMenu"
                                            >
                                              {renderMenuLabel("Check Onbording Status")}
                                            </NavLink>
                                          )}
                                      </li>
                                    );
                                  } else if (
                                    tsk.taskName === "Reporting Details"
                                  ) {
                                    return (
                                      <li className="nav-item">
                                        <NavLink
                                          style={{ color: "black" }}
                                          to="/ReportingDetails"
                                          className="nav-link stepMenu"
                                        >
                                          {renderMenuLabel("Reporting Details")}
                                        </NavLink>
                                      </li>
                                    );
                                  } else if (
                                    tsk.wfPhase === "Time Log" &&
                                    usrType === "candidate"
                                  ) {
                                    return (
                                      <li className="nav-item">
                                        <NavLink
                                          style={{ color: "black" }}
                                          to="/TimeLogs"
                                          className="nav-link stepMenu"
                                        >
                                          {renderMenuLabel("Time Logs")}
                                        </NavLink>
                                      </li>
                                    );
                                  } else if (
                                    tsk.wfPhase === "Time Log" &&
                                    usrType !== "candidate"
                                  ) {
                                    return (
                                      <li className="nav-item">
                                        {(checkMenuPermission("sm10_m2")) && (
                                          <NavLink
                                            style={{ color: "black" }}
                                            to="/PartnerCandidates"
                                            className="nav-link stepMenu"
                                          >
                                            {renderMenuLabel("List of Candidates")}
                                          </NavLink>
                                        )}
                                      </li>
                                    );
                                  } else if (
                                    tsk.wfPhase === "Invoice" &&
                                    usrType !== "candidate"
                                  ) {
                                    return (
                                      <li className="nav-item">
                                        {(checkMenuPermission("sm11_m2")) && (
                                          <NavLink
                                            style={{ color: "black" }}
                                            to="/PartnerInvoices"
                                            className="nav-link stepMenu"
                                          >
                                            {renderMenuLabel("Invoice and Payments")}
                                          </NavLink>
                                        )}
                                      </li>
                                    );
                                  } else if (tsk.wfPhase === "Compliance") {
                                    return (
                                      <li className="nav-item">
                                        <NavLink
                                          style={{ color: "black" }}
                                          to="/Compliance"
                                          className="nav-link stepMenu"
                                        >
                                          {renderMenuLabel("Compliance")}
                                        </NavLink>
                                      </li>
                                    );
                                  } else {
                                    return (
                                      <li className="nav-item">
                                        <NavLink
                                          style={{ color: "black" }}
                                          to="/"
                                          className="nav-link stepMenu"
                                        >
                                          {renderMenuLabel(tsk.taskName)}
                                        </NavLink>
                                      </li>
                                    );
                                  }
                                })}
                            </ul>
                          </div>
                        </>
                      )}
                  </li>
                );
              })}

              <li className="nav-item">
                <h6
                  className="navbar-heading mb-0 btn p-2 rounded-0 text-left text-dark"
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    borderTop: "1px solid #dee2e6",
                    fontWeight: 600,
                  }}
                >
                  <i className="fa fa-wrench mr-2" aria-hidden="true"></i>{isEffectivelyExpanded ? "Tools" : null}
                </h6>
              </li>
              <ul className="nav flex-column">
                <li className="nav-item">
                  <NavLink
                    style={{ color: "black" }}
                    to="/IndividualMsg"
                    className="nav-link stepMenu"
                    title="Use this feature for to and fro communication"
                  >
                    {renderMenuLabel("Message(s)")}
                    {getToolCount(9)}
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    style={{ color: "black" }}
                    to="/FormLibrary"
                    className="nav-link stepMenu"
                    title="Repository of fillable forms to be completed."
                  >
                    {renderMenuLabel("Forms")}
                    {getToolCount(22)}
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    style={{ color: "black" }}
                    to="/SentDocs"
                    className="nav-link stepMenu"
                    title="View history of documents sent and received."
                  >
                    {renderMenuLabel("Document History")}
                    {getToolCount(2)}
                  </NavLink>
                </li>

                {entityType !== "C2C Basis" && (
                  <>
                    <li className="nav-item">
                      <NavLink
                        style={{ color: "black" }}
                        to="/ComplianceRpt"
                        className="nav-link stepMenu"
                        title="In this section you will receive yearly compliance document (1099-NEC)."
                      >
                        {renderMenuLabel("Compliance")}
                        {getToolCount(25)}
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        style={{ color: "black" }}
                        to="/CustomReport"
                        className="nav-link stepMenu"
                        title="View standard reports."
                      >
                        {renderMenuLabel("Reports")}
                      </NavLink>
                    </li>
                  </>
                )}

                <li className="nav-item">
                  <NavLink
                    style={{ color: "black" }}
                    to="/ScheduleMeeting"
                    className="nav-link stepMenu"
                    title="In the event any meeting is scheduled you will accept the same in this section."
                  >
                    {renderMenuLabel("Schedule Meetings")}
                    {getToolCount(11)}
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    style={{ color: "black" }}
                    to="/SurveyFeedback"
                    className="nav-link stepMenu"
                    title="Complete the surveys as part of total customer satisfaction."
                  >
                    {renderMenuLabel("Surveys")}
                  </NavLink>
                </li>
              </ul>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Menu;
